// Account-type classification helpers for dropdown filtering.
//
// Account types are free-form strings in the DB (no enum), so this uses a
// blacklist: unknown/legacy types (e.g. 'Checking', 'Savings', 'Bank', 'Term')
// keep behaving as day-to-day accounts everywhere.
//
// Investment accounts are plain containers: they receive transfers, hold cash
// and carry one `investments` row per product/deposit. The product type
// (STOCK/ETF/deposit) lives on the investment row, not on the account.

// Legacy type previously used for per-product accounts. No longer created by
// the UI; kept here so any leftover 'Shares' accounts still classify as
// investment accounts until they are folded in.
export const INVESTMENT_ACCOUNT_TYPES = ['Investment', 'Shares'];

export const isInvestmentAccount = (account) =>
  INVESTMENT_ACCOUNT_TYPES.includes((account?.type || '').trim());

export const isDayToDayAccount = (account) => !isInvestmentAccount(account);

// Filter lists for the various dropdown contexts (per product decisions):
// - Expense/Income forms, imports, default-account setting: day-to-day only.
export const dayToDayAccounts = (accounts) => (accounts || []).filter(isDayToDayAccount);

// - Transfer forms and the transactions-page filter: everything open.
export const openAccounts = (accounts) => (accounts || []).filter((a) => a.is_open);

// - Investments page: strict 'Investment' accounts only (legacy 'Shares'
//   accounts are not shown; fold them in via sql/migrate_product_accounts.py).
export const investmentAccounts = (accounts) =>
  (accounts || []).filter((a) => (a.type || '').trim() === 'Investment');